import {AirtimeConnection, AirtimeCostReport, AirtimeDeviceCalculation, ExchangeRates, Invoice, PaymentAccount, Transactions} from './api'
import {Injectable} from '@angular/core'

@Injectable({providedIn: 'root'})
export class AllServices {
  constructor(
    public AirtimeConnection: AirtimeConnection,
    public AirtimeCostReport: AirtimeCostReport,
    public AirtimeDeviceCalculation: AirtimeDeviceCalculation,
    public ExchangeRates: ExchangeRates,
    public Invoice: Invoice,
    public PaymentAccount: PaymentAccount,
    public Transactions: Transactions,
  ) {}
}